import { useState } from "react";
import { lookupDimensions, lookupStats } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function ResourceLookup() {
  const [active, setActive] = useState(lookupDimensions[0].key);
  const current = lookupDimensions.find((d) => d.key === active) ?? lookupDimensions[0];

  return (
    <section id="lookup" className="bg-background-50 px-6 lg:px-10 py-14 md:py-20 scroll-mt-24">
      <SectionHeading
        index="05"
        label="Resource Lookup"
        title="资源速查"
        desc="已经知道自己想看什么？按题材、时长、场景或热度直接筛，比一层层点进去更快。"
      />

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-6">
        <div className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6">
          <div className="flex flex-wrap items-center gap-1 p-1 rounded-full bg-background-50 border border-background-200 w-full sm:w-fit">
            {lookupDimensions.map((dim) => (
              <button
                key={dim.key}
                type="button"
                onClick={() => setActive(dim.key)}
                className={`px-4 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  active === dim.key
                    ? "bg-secondary-500 text-background-50"
                    : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                {dim.key}
              </button>
            ))}
          </div>

          <p className="mt-5 text-xs text-foreground-500 flex items-center gap-1.5">
            <i className="ri-guide-line"></i>
            {current.hint}
          </p>

          <div className="mt-3 flex flex-wrap gap-2.5">
            {current.tags.map((tag) => (
              <a
                key={tag}
                href="#index"
                className="px-4 py-2 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-800 hover:border-secondary-400 hover:text-secondary-800 transition-colors cursor-pointer"
              >
                {tag}
              </a>
            ))}
          </div>
        </div>

        <div className="rounded-lg bg-secondary-950 text-background-50 p-6 flex flex-col justify-between">
          <div>
            <span className="font-label text-[11px] tracking-[0.2em] uppercase text-accent-400">
              This Week
            </span>
            <p className="mt-3 font-heading font-bold text-xl leading-snug">
              本周新增 1,286 条资源，
              <br />
              覆盖 4 大查找维度。
            </p>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-4">
            {lookupStats.map((stat) => (
              <div key={stat.label}>
                <span className="font-label text-2xl text-accent-400">{stat.value}</span>
                <p className="mt-1 text-xs text-secondary-200">
                  {stat.label} · {stat.unit}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}